export default "__VITE_ASSET__9e02727d__"